// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../index';

import { FilterPriceRangeFragmentDoc } from '../../../fragments/filters/filterPriceRange.fragment.generated';
import { MoneyFragmentDoc } from '../../../../../fragments/money.fragment.generated';
import { FilterEngagementRingStyleFragmentDoc } from '../../../fragments/filters/filterEngagementRingStyle.fragment.generated';
import { FacetedContentProductLabelTranslationFragmentDoc } from '../../../../../../../domain/product/useFacetedContent.generated';
import { FilterEngagementRingDesignFeatureFragmentDoc } from '../../../fragments/filters/filterEngagementRingDesignFeature.fragment.generated';
import { FilterEngagementRingDesignStyleFragmentDoc } from '../../../fragments/filters/filterEngagementRingDesignStyle.fragment.generated';
import { FilterShapeFragmentDoc } from './filterShape.fragment.generated';
import { MetalFilterFragmentDoc, MetalFilterMetalFragmentDoc } from '../../../fragments/filters/metalFilter.fragment.generated';
export const EngagementRingFiltersFragmentDoc = `
    fragment engagementRingFilters on CatalogueEngagementRingFilters {
  price(input: {currency: $currency, country: $country}) {
    ...filterPriceRange
  }
  ringStyles {
    ...filterEngagementRingStyle
  }
  designFeatures {
    ...filterEngagementRingDesignFeature
  }
  designStyles {
    ...filterEngagementRingDesignStyle
  }
  centreStoneShapes {
    ...filterShape
  }
  primaryMetals {
    ...metalFilter
  }
}
    `;